import React, { useEffect, useState } from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { writeField } from '../fieldFunction';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { player1CurrentSquaresState } from '../../../globalStates/general/player1CurrentSquare';
import { isReverseState } from '../../../globalStates/general/reverse';
import { fieldDataState } from '../../../globalStates/general/fieldData';
import { gameStatusState } from '../../../globalStates/general/gameStatus';
import { warpWindowDisplayState } from '../../../globalStates/item/warpWindowDisplay';
import { useMedia } from 'use-media';

const WarpWindow = (props) => {
  const [player1Square, setPlayer1Square] = useRecoilState(player1CurrentSquaresState);
  const [reverse, setReverse] = useRecoilState(isReverseState);
  // フィールドのデータを管理する
  const [fieldData, setFieldData] = useRecoilState(fieldDataState);
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [warpWindowDisplay, setWarpWindowDisplay] = useRecoilState(warpWindowDisplayState);
  const [contentDisplay, setContentDisplay] = useState("none");
  const isPC = useMedia({ minWidth: 1000 });
  const isTablet = useMedia({ minWidth: 1000, maxWidth: 1400 });

  useEffect(() => {
    const gridElement = document.querySelectorAll('.grid'); //　全てのグリッド要素を取得する;
    gridElement.forEach((element) => {
      element.addEventListener('mouseover', (e) => {
        const selectGrid = e.target.getAttribute("value");
        handleHover(Number(selectGrid), gridElement, "hover");
      })
      element.addEventListener('mouseleave', (e) => {
        const selectGrid = e.target.getAttribute("value");
        handleHover(Number(selectGrid), gridElement, "leave");
      })
      element.addEventListener('click', (e) => {
        const selectGrid = e.target.getAttribute("value");
        setPlayer1Square(Number(selectGrid));
        setGameStatusValue(2);
        setWarpWindowDisplay("none");
      })
    });

  }, []);


  useEffect(() => {
    if (warpWindowDisplay === "block") {
      setTimeout(() => {
        setContentDisplay("block");
        if (document.querySelector(".fieldArea")) {
          document.querySelector(".fieldArea").style.display = "none";
        }
      }, 1000);
    } else {
      setContentDisplay("none");
      if (document.querySelector(".fieldArea")) {
        document.querySelector(".fieldArea").style.display = "block";
      }
    }
  }, [warpWindowDisplay])

  // 進むマスのボタンにホバーした時、進むマスにアニメーションを施す。
  const handleHover = (nextGrid, gridElement, status) => {
    if (status === "hover") {
      if (gridElement[nextGrid - 1]) {
        gridElement[nextGrid - 1].setAttribute("id", "nextGrid");
      }
    }
    else if (status === "leave") {
      if (gridElement[nextGrid - 1]) {
        gridElement[nextGrid - 1].setAttribute("id", "");
      }
    }
  }
  const fieldContent = writeField(props.fieldData, true);

  // style
  const warpWindowArea = css`
    h4 {
      margin: 0 auto;
    }
    overflow: hidden;
    @keyframes fadeIn {
      0% {
        border-bottom-right-radius: 100%;
        width: 0;
        height: 0;
      }
      100% {
        border-bottom-right-radius: 0%;
        /* width: 100vw; */
        height: ${isPC ? "calc(100vh - 160px)" : "100vh"};
      }
    }

    animation: fadeIn ease 1s;
    display: ${warpWindowDisplay};
    position: absolute;
    top: ${isTablet ? "-10px" : "0"};
    left: ${isTablet ? "-100px" : "0"};
    width: 100vw;
    height: ${isPC ? "calc(100vh - 160px)" : "100vh"};
    background-color: white;
    z-index: 9;
  `;
  const gridAreaWrap = css`
    display: ${contentDisplay};
    text-align: center;
    overflow: hidden;
    /* margin-top: 100px; */

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }

    animation: fadeIn ease 1s;
  `;
  const gridArea = css`
    z-index: 2;
    .grid {
      cursor: pointer;
      z-index: 10;
    }
    overflow-y: scroll;
    /* transform: translateY(-15%); */
    width: ${isPC ? "40vw" : "100vw"};
    height: ${isPC ? "calc(100vh - 160px)" : "100vh"};
    margin: ${isPC ? "0 0 0 0" : ""};
    display: flex;
    flex-wrap: wrap;
    // 次に進む予定のマスのCSS
    @keyframes pulseMotion {
      0% {
        transform: translate(-50%, -50%) scale(1, 1);
        background-color: rgba(130, 213, 255, 0.4)
      }
      100% {
        transform: translate(-50%, -50%) scale(2, 2);
        background-color: rgba(130, 213, 255, 0)
      }
    }

    #nextGrid {
      overflow: hidden;
      cursor: pointer;
      &:after {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transition: opacity linear 0.4s;
        content: '';
        animation: pulseMotion 1.3s linear infinite;
      }
    }

    // each grid
    div {
      background-color: #ffffff;
      font-family: 'Exo 2';
      border-radius: 15px;
      padding: 10px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
      margin-top: 20px;
      width: 100px;
      height: 100px;
      border: 1px solid black;
      span {
        position: absolute;
        top: 20px;
        color: blue;
      }
    }
  `;
  return (

    <div css={warpWindowArea}>
      <h4 style={{ position: 'absolute', top: 0, left: 0, backgroundColor: 'white', zIndex: 20 }}>
        ワープしたいマスを選択してください。
      </h4>
      <div css={gridAreaWrap}>
        <div css={gridArea}>
          {fieldContent}
        </div>
      </div>
    </div>
  )
}

export default WarpWindow
